import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireMimeMatch } from "../node_modules/.pnpm/mime-match@1.0.2/node_modules/mime-match/index.js";
var mimeMatchExports = requireMimeMatch();
const match = /* @__PURE__ */ getDefaultExportFromCjs(mimeMatchExports);
export {
  match as default
};
//# sourceMappingURL=index3.js.map
